import { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import logo from '../../assets/images/logos/light-logo.svg';
import useAuth from 'src/guards/authGuard/UseAuth';

const phoneNumber = '+000  000 0000';
const address = 'Beverley, New York 224 USA';

const socialList = [
  {
    iconName: 'icofont-facebook-messenger',
    siteLink: '#',
  },
  {
    iconName: 'icofont-twitter',
    siteLink: '#',
  },
  {
    iconName: 'icofont-vimeo',
    siteLink: '#',
  },
  {
    iconName: 'icofont-skype',
    siteLink: '#',
  },
  {
    iconName: 'icofont-rss-feed',
    siteLink: '#',
  },
];

const Header = () => {
  const { isAuthenticated, logout, role } = useAuth();

  const [menuToggle, setMenuToggle] = useState(false);
  const [socialToggle, setSocialToggle] = useState(false);
  const [headerFiexd, setHeaderFiexd] = useState(false);

  window.addEventListener('scroll', () => {
    if (window.scrollY > 200) {
      setHeaderFiexd(true);
    } else {
      setHeaderFiexd(false);
    }
  });

  return (
    <header className={`header-section ${headerFiexd ? 'header-fixed fadeInUp' : ''}`}>
      <div className={`header-top ${socialToggle ? 'open' : ''}`}>
        <div className="container">
          <div className="header-top-area">
            <ul className="lab-ul left">
              <li>
                <i className="icofont-ui-call"></i> <span>{phoneNumber}</span>
              </li>
              <li>
                <i className="icofont-location-pin"></i> {address}
              </li>
            </ul>
            <ul className="lab-ul social-icons d-flex align-items-center">
              <li>
                <p>Find us on : </p>
              </li>
              {socialList.map((val, i) => (
                <li key={i}>
                  <a href={val.siteLink}>
                    <i className={val.iconName}></i>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <div className="header-bottom">
        <div className="container">
          <div className="header-wrapper">
            <div className="logo">
              <Link to="/">
                <img src={logo} alt="logo" style={{ height: '42px' }} />
              </Link>
            </div>
            <div className="menu-area">
              <div className="menu">
                <ul className={`lab-ul ${menuToggle ? 'active' : ''}`}>
                  <li>
                    <NavLink to="/">Course</NavLink>
                  </li>
                  <li>
                    <NavLink to="/about">About</NavLink>
                  </li>

                  <li>
                    <NavLink to="/contact">Contact</NavLink>
                  </li>
                </ul>
              </div>
              {isAuthenticated ? (
                <>
                  <Link to={`/${role}`} className="login">
                    <i className="icofont-user"></i> <span>Dashboard</span>{' '}
                  </Link>
                  <button className="signup" onClick={logout}>
                    <i className="icofont-logout"></i> <span>logout</span>{' '}
                  </button>
                </>
              ) : (
                <>
                  <Link to="/login" className="login">
                    <i className="icofont-user"></i> <span>LOG IN</span>{' '}
                  </Link>
                  <Link to="/signup" className="signup">
                    <i className="icofont-users"></i> <span>SIGN UP</span>{' '}
                  </Link>
                  <Link to="/auth/teacher/login" className="login">
                    <i className="icofont-teacher"></i> <span>Techer</span>{' '}
                  </Link>
                </>
              )}

              <div
                className={`header-bar d-lg-none ${menuToggle ? 'active' : ''}`}
                onClick={() => setMenuToggle(!menuToggle)}
              >
                <span></span>
                <span></span>
                <span></span>
              </div>
              <div
                className="ellepsis-bar d-lg-none"
                onClick={() => setSocialToggle(!socialToggle)}
              >
                <i className="icofont-info-square"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
